import { Joyride, STATUS } from 'react-joyride';
import { useTheme } from 'styled-components';
import { useLocalStorage } from 'hooks';

// react-joyride v3 note: `skipBeacon` (not v2's `disableBeacon`) is what
// skips the click-to-reveal beacon and shows the tooltip immediately.
// `blockTargetInteraction` defaults to false in v3, meaning the spotlighted
// target is already click-through by default — step 1's real click on the
// Drawing toggle is what makes step 2/3's targets exist, no extra config
// needed for that.
const STEPS = [
  {
    target: '[data-tour="drawing-toggle"]',
    title: 'Draw on the map',
    content: "Tap here to start drawing pixels anywhere within 200 yards of you.",
    skipBeacon: true,
  },
  {
    target: '[data-tour="wall-panel"]',
    title: 'Pick a color',
    content: 'Tap a color swatch, then tap any tile on the map to place a pixel there.',
    skipBeacon: true,
  },
  {
    target: '[data-tour="wall-save"]',
    title: 'Save your art',
    content: "You've got 256 pixels a day. Hit save when you're happy — a cell can't be redrawn again for 24 hours after it's saved.",
    skipBeacon: true,
  },
];

// One-time walkthrough of the wall drawing game, shown the first time someone
// lands on the map.
export const WallTour = () => {
  const { colors, monoFont } = useTheme();
  const [seen, setSeen] = useLocalStorage('wall_tour_seen', false);

  if (seen) return null;

  const handleEvent = ({ status }) => {
    if (status && [STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setSeen(true);
    }
  };

  return (
    <Joyride
      run
      steps={STEPS}
      onEvent={handleEvent}
      options={{
        arrowColor: colors('chrome'),
        backgroundColor: colors('chrome'),
        overlayColor: colors('shadow', 0.75),
        primaryColor: colors('link'),
        textColor: colors('text'),
        zIndex: 10001,
        showProgress: true,
      }}
      styles={{
        tooltip: {
          fontFamily: monoFont,
        },
        buttonPrimary: {
          fontFamily: monoFont,
        },
        buttonBack: {
          fontFamily: monoFont,
        },
      }}
    />
  );
};
